

































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';

import * as bases_store from '../../BasesManager/_store';
import { STORE_KEY, store } from './_store';
import ShiftVdpIngredientsForm from "./ShiftVdpIngredientsForm/ShiftVdpIngredientsForm.vue";
import BatchesManagerForm from "./BatchesManagerForm/BatchesManagerForm.vue";
import XLSX from "xlsx";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'relatedFactsList',

      // 'document', 'meta'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
      'remainsById', 'totals'
    ]),
  },
})
export default class ShiftVDPIngredients extends Vue {

  @Prop() documentId!: string;

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
    // @ts-ignore
    if (!(bases_store.STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(bases_store.STORE_KEY, bases_store.store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }
  public printDocument(row_id: any) {
    this.$store.dispatch(`$_bases_manger/printDocument`, row_id);
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }
  openDocument(row: any, base_id: boolean, plan_id: any) {
    console.log('row', row);
    if (!row || !row.id) {
      this.$buefy.modal.open({
        component: BatchesManagerForm,
        props: {
          isNew: true,
          documentPreview: row,
          documentId: this.documentId,
          ingredientId: row.ingredient_id,
          initParams: {
            shift_id: this.documentId,
            base_id: base_id,
            plan_id: plan_id,
            ingredient_id: row.ingredient_id,
            total_weight: row.weight,
            ...row
          }
        },
        events: {
          'form-close': (result: any) => {
            result = result.result;
            console.log('result', result);
            this.$buefy.modal.open({
              component: ShiftVdpIngredientsForm,
              props: {
                isNew: !row || !row.id,
                documentPreview: row,
                documentId: this.documentId,
                ingredientId: result.ingredient_id,
                initParams: {
                  shift_id: this.documentId,
                  batch_id: result.id,
                  base_id: base_id,
                  ingredient_id: result.ingredient_id,
                  plan_id: plan_id,
                  weight: result.total_weight,
                }
              },
              events: {
                'form-close': () => {
                  this.handleParamsChange();
                },
              },
              hasModalCard: true,
              fullScreen: true,
              customClass: 'document-form short-form',
              parent: this
            })
          },
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: 'document-form short-form',
        parent: this
      })
    } else {
      this.$buefy.modal.open({
        component: ShiftVdpIngredientsForm,
        props: {
          isNew: !row || !row.id,
          documentPreview: row,
          documentId: this.documentId,
          ingredientId: row.ingredient_id,
          initParams: {
            shift_id: this.documentId,
            base_id: base_id,
            ingredientId: row.ingredient_id,
            ...row
          }
        },
        events: {
          'form-close': () => {
            this.handleParamsChange();
          },
        },
        hasModalCard: true,
        fullScreen: true,
        customClass: 'document-form short-form',
        parent: this
      })
    }
  }
  tableToExcel(rows: any[]) {
    const csvContent: any[] = [[
        "Наименование`",
      "Кол-во, г",
      "Производитель`",
      "Дата производства`",
      "№ партии"
    ]];

    csvContent.push(...rows.map((item: any) => {
      return [item.name, item.weight, item.manufacturer, item.datetime, item.batch_number]
    }));
    console.log('rows', csvContent);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws['!ref']);
    for(let R = range.s.r; R <= range.e.r; ++R) {

      for(let C = range.s.c; C <= range.e.c; ++C) {
        const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
        if(!ws[cellref] || C !== 2 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        cell.t = 'n'
        cell.z = '0.00'
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, 'export.xlsx')
  }
}

